<ion-app>
  <div
    class="force-update-overlay"
    *ngIf="appUpdateService.forceUpdate"
    data-testid="force-update-overlay"
  >
    <div class="force-update-card">
      <div class="force-update-icon">
        <ion-icon name="cloud-download-outline"></ion-icon>
      </div>
      <h2>{{ "APP_UPDATE.FORCE_TITLE" | translate }}</h2>
      <p>{{ "APP_UPDATE.FORCE_MESSAGE" | translate }}</p>
      <ion-button expand="block" (click)="appUpdateService.openStore()">
        {{ "APP_UPDATE.UPDATE_NOW" | translate }}
      </ion-button>
    </div>
  </div>

  <aside
    class="optional-update-banner"
    *ngIf="appUpdateService.optionalUpdate && !appUpdateService.forceUpdate"
    data-testid="optional-update-banner"
    role="status"
  >
    <div class="optional-update-card">
      <button
        type="button"
        class="optional-update-close"
        (click)="appUpdateService.dismissOptional()"
        [attr.aria-label]="'APP_UPDATE.LATER' | translate"
      >
        <ion-icon name="close"></ion-icon>
      </button>

      <div class="optional-update-icon">
        <ion-icon name="cloud-download-outline"></ion-icon>
      </div>

      <div class="optional-update-copy">
        <strong>{{ "APP_UPDATE.OPTIONAL_TITLE" | translate }}</strong>
        <p>{{ "APP_UPDATE.OPTIONAL_MESSAGE" | translate }}</p>
      </div>

      <div class="optional-update-actions">
        <ion-button
          fill="clear"
          class="optional-update-later"
          (click)="appUpdateService.dismissOptional()"
        >
          {{ "APP_UPDATE.LATER" | translate }}
        </ion-button>
        <ion-button
          class="optional-update-cta"
          (click)="appUpdateService.openStore()"
        >
          {{ "APP_UPDATE.UPDATE_NOW" | translate }}
        </ion-button>
      </div>
    </div>
  </aside>

  <ion-header class="app-main-header" *ngIf="showHeader && !appUpdateService.forceUpdate">
    <ion-toolbar>
      <div dir="ltr" class="app-header-bar">
        <div
          dir="ltr"
          class="app-brand-header"
          role="button"
          tabindex="0"
          (click)="goToHome()"
          (keydown.enter)="goToHome()"
          (keydown.space)="$event.preventDefault(); goToHome()"
        >
          <div class="app-brand-mark">
            <img
              src="assets/ic_launcher_round.png"
              alt="{{ 'COMMON.APP_LOGO' | translate }}"
            />
          </div>

          <h1>Bidarbak</h1>
        </div>

        <button
          type="button"
          class="header-update-alert"
          *ngIf="appUpdateService.optionalUpdateMinimized"
          data-testid="header-update-alert"
          (click)="appUpdateService.openStore()"
        >
          <ion-icon name="cloud-download-outline"></ion-icon>
          <span>{{ "APP_UPDATE.HEADER_ALERT" | translate }}</span>
        </button>
      </div>
    </ion-toolbar>
  </ion-header>

  <ion-router-outlet [swipeGesture]="rootSwipeEnabled"></ion-router-outlet>

  <ion-footer *ngIf="showTabBar && !appUpdateService.forceUpdate" slot="fixed">
    <ion-toolbar>
      <ion-segment
        class="footer-segment"
        [class.footer-segment-admin]="authService.isAdmin()"
        [(ngModel)]="activeTab"
      >
        <ion-segment-button
          value="home"
          data-testid="tab-home"
          (click)="onSegmentClick('home')"
        >
          <div class="icon-wrapper">
            <ion-icon name="home-outline"></ion-icon>
          </div>
          <ion-label>{{ "TAB.HOME" | translate }}</ion-label>
        </ion-segment-button>

        <ion-segment-button
          value="rides"
          data-testid="tab-rides"
          (click)="onSegmentClick('rides')"
        >
          <div class="icon-wrapper">
            <ion-icon name="car-outline"></ion-icon>
          </div>
          <ion-label>{{ "TAB.RIDES" | translate }}</ion-label>
        </ion-segment-button>

        <ion-segment-button
          value="admin"
          *ngIf="authService.isAdmin()"
          data-testid="tab-admin"
          (click)="onSegmentClick('admin')"
        >
          <div class="icon-wrapper">
            <ion-icon name="shield-outline"></ion-icon>
          </div>
          <ion-label>{{ "TAB.ADMIN" | translate }}</ion-label>
        </ion-segment-button>

        <ion-segment-button
          value="profile"
          data-testid="tab-profile"
          (click)="onSegmentClick('profile')"
        >
          <div class="icon-wrapper">
            <ion-icon name="person-outline"></ion-icon>
          </div>
          <ion-label>{{ "TAB.PROFILE" | translate }}</ion-label>
        </ion-segment-button>

        <ion-segment-button
          value="notifications"
          data-testid="tab-alerts"
          (click)="onSegmentClick('notifications')"
        >
          <div class="icon-wrapper">
            <ion-icon name="notifications-outline"></ion-icon>
            <ion-badge
              *ngIf="pushService.unreadCount > 0"
              class="notification-badge"
              color="danger"
            >
              {{ pushService.unreadCount }}
            </ion-badge>
          </div>
          <ion-label>{{ "TAB.ALERTS" | translate }}</ion-label>
        </ion-segment-button>
      </ion-segment>
    </ion-toolbar>
  </ion-footer>
</ion-app>
